import React, { useRef, useEffect } from 'react';

const categories = [
  { id: 1, title: 'Necklaces', img: '/assets/demo/category/creative-1.png' },
  { id: 2, title: 'Earrings', img: '/assets/demo/category/creative-2.png' },
  { id: 3, title: 'Rings', img: '/assets/demo/category/creative-3.png' },
  { id: 4, title: 'Bangles', img: '/assets/demo/category/creative-4.png' },
  { id: 5, title: 'Necklace + Earrings', img: '/assets/demo/category/creative-5.png' },
];

const CategorySection = () => {
  const sliderRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      if (sliderRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = sliderRef.current;
        // Only auto-slide if content is wider than container (i.e. mobile view)
        if (scrollWidth > clientWidth) {
          let nextScroll = scrollLeft + clientWidth * 0.85;
          // Reset to beginning if we reached the end
          if (nextScroll >= scrollWidth - clientWidth + 10) {
            nextScroll = 0;
          }
          sliderRef.current.scrollTo({ left: nextScroll, behavior: 'smooth' });
        }
      }
    }, 2500); // Auto slide every 2.5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="new-demo-category-section">
      <div className="demo-content-container">
        <div className="new-demo-category-header text-center mb-5">
          <div className="new-demo-category-badge d-inline-block mb-3">
            Every Category
          </div>
          <h2 className="new-demo-category-title mb-3">
            Every Jewellery Type. Every Visual You Need.
          </h2>
          <p className="new-demo-category-subtitle">
            Trained on millions of luxury references — from<br className="d-none d-md-block" />
            delicate studs to statement bridal sets.
          </p>
        </div>

        <div className="new-demo-category-slider" ref={sliderRef}>
          {categories
            // .sort((a, b) => a.order - b.order)
            .map((cat) => (
              <div key={cat.id} className="new-demo-category-card">
                <img src={cat.img} alt={cat.title} />

                <div className="new-demo-category-overlay">
                  <h3 className="new-demo-category-title-text">
                    {cat.title}
                  </h3>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;
